import React, { Component } from 'react'
import { Alert, Container, Row, Col, Button, Card, CardHeader} from "shards-react";
import { Form } from 'react-bootstrap'
import { Redirect } from 'react-router-dom'
import {PropTypes} from 'prop-types'
import {connect} from 'react-redux'

import PageTitle from "./../../components/common/PageTitle";
import auth from '../../components/common/Auth';
import history from '../../history';
import { AccountsAPI } from '../../components/apis';


// const parentUrl = process.env.REACT_APP_RE_URL;
//TODO Porque no usa la API de Accounts?

class EditAccount extends Component {

  constructor (props, context) {
    super(props, context)
    this.props = props;
    this.state = {
      loading: false,
      goToAccounts: false,
      apiErr: null,
      formValidated: true,
    }
    this.data = {
      enabled: true,
    }
    this.api = new AccountsAPI(auth.getAccessToken());
  }

  handleChange = (field, event) => {

    if (field === 'enabled') {
      this.setState({
        [field]: event.target.value === 'true'
      })
    } else {
      this.setState({
        [field]: event.target.value
      })
    }
  }


  handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    var id = this.props.id;
    const self = this;

    if (form.checkValidity() === false) {
      this.setState({
        formValidated: false,
      })
      return;
    }

    this.setState({
      loading: true
    })
    // const token = auth.getAccessToken()

    const account = {
        "id": id,
        "name" : this.state.name,
        "email" : this.state.email,
        "address" : this.state.address,
        "floor" : this.state.floor,
        "department" : this.state.department,
        "business_id" : this.state.business_id,
        "phone_number" : this.state.phone_number,
        "enabled" : this.state.enabled
    }

    this.api.update(account).then(() => {
      self.setState({
         loading: false,
         goToAccounts: true
      })
    }).catch(err => {
      self.setState({
         apiErr: err,
         loading: false
      })
    });

  }

  componentDidMount () {
    this._getAccount()
  }

 _getAccount() {
    this.setState({
      loadingAccount: true,
    });

    const self = this;
    this.api.get(this.props.id).then(account => {

      self.setState({
        loading: false,
        name : account.name,
        email : account.email,
        address : account.address,
        floor : account.floor,
        department : account.department,
        business_id : account.business_id,
        phone_number : account.phone_number,
        enabled : account.enabled
      })
    }).catch(err => {
      self.setState({
        loading: false,
        apiErr: err,
      })
    });
  }

  goBack = () => {
    history.goBack();
  }

  render = () => {
    // if(auth.isAuthenticated()){
        if (this.state.loading) {
          return (
            <div>
              <Container fluid>
                <br/>
                <div className="container center">
                    <h5><i className="fas fa-spinner fa-pulse"></i> {this.context.t('Loading...')}</h5>
                </div>
              </Container>
            </div>
          )
        }

        if (this.state.goToAccounts){
            return <Redirect to='/accounts' />
        }

        let error
        if (this.state.apiErr) {
          error =  <Container fluid className="px-0"><Alert dismissible={this.dismiss} open={this.state.alertVisible} className="alert-accent mb-0"><i className="material-icons">error</i> {this.context.t('There was a mistake')}:  {this.state.apiErr.message}</Alert></Container>
        }

        return (
          <div>

            {error}

            <Container fluid>

              <Row noGutters className="page-header py-4">
                <PageTitle title={this.context.t('Accounts')} subtitle={this.context.t('Edit')} className="text-sm-left mb-3" />
              </Row>

              <Card small style={{ marginBottom: '20px'}}>
                <CardHeader className="border-bottom">
                  <h5 className="m-0">
                      <i className="material-icons blue-text md-24" style={{float: "left"}}>verified_user</i>
                      <span style={{float: "left", marginTop: "2px", marginLeft: "2px"}}>{this.state.name}</span>
                  </h5>

                  <i className="material-icons mx-3" style={{ float: "right", cursor: "pointer", fontSize: "20px"}}  onClick={e => {this.goBack()}}>arrow_back</i>

                </CardHeader>
                <Form validate="true" onSubmit={e => this.handleSubmit(e)} style={{ padding: "10px"}}>
                    <Row>
                        <Col lg="6">
                            <Form.Group controlId='name'>
                              <Form.Label>{this.context.t('Name of the company')}</Form.Label>
                              <Form.Control type='text' placeholder={this.context.t('Company Name')} value={this.state.name} onChange={e => {this.handleChange('name', e)}} required/>
                            </Form.Group>

                            <Form.Group controlId='business_id'>
                              <Form.Label>{this.context.t('Business ID')}</Form.Label>
                              <Form.Control type='text' placeholder='22-33444555-6' value={this.state.business_id} onChange={e => {this.handleChange('business_id', e)}} required/>
                            </Form.Group>

                            <Form.Group controlId='email'>
                              <Form.Label>{this.context.t('Email')}</Form.Label>
                              <Form.Control type='email' value={this.state.email} placeholder={this.context.t('company@email.com')}  onChange={e => {this.handleChange('email', e)}} required/>
                            </Form.Group>

                            <Form.Group controlId='phone_number'>
                              <Form.Label>{this.context.t('Phone')}</Form.Label>
                              <Form.Control type='text' value={this.state.phone_number} placeholder={this.context.t('1-541-754-3010')}  onChange={e => {this.handleChange('phone_number', e)}} required/>
                            </Form.Group>
                        </Col>
                        <Col lg="6">
                            <Form.Group controlId='address'>
                              <Form.Label>{this.context.t('Address')}</Form.Label>
                              <Form.Control type='text' value={this.state.address} placeholder={this.context.t('260 5th Ave, New York, NY 10001, EE. UU.')}  onChange={e => {this.handleChange('address', e)}}/>
                            </Form.Group>

                            <Form.Group controlId='floor'>
                              <Form.Label>{this.context.t('Floor')}</Form.Label>
                              <Form.Control type='text' value={this.state.floor} placeholder={this.context.t('PB')}  onChange={e => {this.handleChange('floor', e)}}/>
                            </Form.Group>

                            <Form.Group controlId='department'>
                              <Form.Label>{this.context.t('department')}</Form.Label>
                              <Form.Control type='text' value={this.state.department} placeholder="1"  onChange={e => {this.handleChange('department', e)}}/>
                            </Form.Group>

                            <Form.Group controlId="enabled">
                              <Form.Label>{this.context.t('Enabled')}</Form.Label>
                              <Form.Control as="select" onChange={e => {this.handleChange('enabled', e)}} value={this.state.enabled}>
                                <option value="true">{this.context.t('Yes')}</option>
                                <option value="false">{this.context.t('No')}</option>
                              </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>

                    <hr/>

                    <Button theme="primary" outline className="mb-2 mr-1" type='submit'>{this.context.t('Save')}</Button>
                    &nbsp;
                    <Button theme="secondary" outline className="mb-2 mr-1" onClick={this.goBack}>{this.context.t('Cancel')}</Button>
                  </Form>
              </Card>

            </Container>
          </div>
        )
    // }else{
    //     return <Redirect to='/' />
    // }
  }
}

EditAccount.contextTypes = {
  t: PropTypes.func.isRequired
}

export default connect(state => ({
  lang: state.i18nState.lang
}))(EditAccount)
